var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16.352 16.358"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#4a4a4a",
    stroke: "#4a4a4a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.475 15.315l-3.35.918.932-3.336zM15.659 3.725l-.689.689-3.026-3.026.689-.689a1.614 1.614 0 012.269 0l.757.756a1.616 1.616 0 010 2.27zM1.651 11.681l9.388-9.388 3.025 3.026-9.387 9.388z"
  }))));
}
export default __webpack_public_path__ + "37a21b160fc7d99b4a481b471a3e169f.svg";
export { SvgEditIcon as ReactComponent };